import { defineListFilter } from '../engine/descriptor';
import { FilterId, FilterType } from '../types/filters';

export const remoteTypeDescriptor = defineListFilter({
  definition: {
    id: FilterId.REMOTE_TYPE,
    name: 'Remote Type',
    selectionListId: 'remote_type',
    selections: [],
    type: FilterType.LIST,
    isVisible: true,
  },
  multi: { id: FilterId.MULTI_REMOTE_TYPE },
});
